import React, {useState} from 'react';
import './AccordionDropdown.css';
import PropTypes from 'prop-types';
import accordionMinus from '../../../assets/icons/minus.svg';
import accordionPlus from '../../../assets/icons/plus.svg';

export function AccordionDropdown(props) {
  const {title, content} = props;
  const [toggleFAQ, setToggleFAQ] = useState(false);

  return (
    <div className='prequal--web--accordion-dropdown-container'>
      <div
        data-testid='accordion-dropdown-title'
        className={`prequal--web--accordion-dropdown-title ${toggleFAQ ? 'active' : 'inactive'}`}
        onClick={() => {
          setToggleFAQ(!toggleFAQ);
        }}
        role='presentation'
      >
        <div className='title'>{title}</div>
        <div className='prequal--web--expand-icon' data-testid='accordion-buttons'>
          {!toggleFAQ && <img className='accordion-plus' src={accordionPlus} alt='accordionPlus' data-testid='accordion-plus' />}
          {toggleFAQ && <img className='accordion-minus' src={accordionMinus} alt='accordionMinus' data-testid='accordion-minus' />}
        </div>
      </div>
      <div className={`prequal--web--accordion-details ${toggleFAQ ? 'active' : 'inactive'}`} data-testid='accordion-dropdown-content'>
        <div className='prequal--web--accordion-content-paragraph'>{content}</div>
      </div>
    </div>
  );
}

AccordionDropdown.propTypes = {title: PropTypes.string, content: PropTypes.any};
AccordionDropdown.defaultProps = {title: '', content: ''};
